import Vue from 'vue';
import Router from 'vue-router';

import ErrIndex from '../page/error/Index';

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(Router);

export function createRouter() {
  return new Router({
    mode: 'history',
    fallback: false,
    routes: [
      // 首页
      {
        path: '/home',
        name: 'home',
        meta: {
          mtype: 'home',
        },
        alias: ['/', '/index.html'],
        component: () => import(/* webpackChunkName: "home" */ '../page/home/Index.vue'),
      },
      // 搜索结果页
      {
        path: '/v',
        name: 'v',
        meta: {
          mtype: 'search',
          addSearch: true,
        },
        component: () => import(/* webpackChunkName: "search" */ '../page/search/Index.vue'),
      },
      {
        path: '/search',
        name: 'search',
        meta: {
          mtype: 'search',
          addSearch: true,
        },
        component: () => import(/* webpackChunkName: "search" */ '../page/search/Index.vue'),
      },
      {
        path: '/vertical/:key',
        name: 'vertical',
        meta: {
          mtype: 'search',
          addSearch: true,
        },
        component: () => import(/* webpackChunkName: "search" */ '../page/search/Index.vue'),
      },
      // 明星详情页
      {
        path: '/star',
        name: 'star',
        meta: {
          mtype: 'star',
        },
        component: () => import(/* webpackChunkName: "starDetail" */ '../page/search/Star.vue'),
      },
      // 列表页
      {
        path: '/list',
        name: 'list',
        meta: {
          mtype: 'list',
        },
        component: () => import(/* webpackChunkName: "classList" */ '../page/search/List.vue'),
      },
      // 热门搜索页
      {
        path: '/hotsugg',
        name: 'hotsugg',
        meta: {
          mtype: 'hotsugg',
        },
        component: () => import(/* webpackChunkName: "hotsugg" */ '../page/hotsugg/Index.vue'),
      },
      // 电影详情页
      {
        path: '/dy/:dockey/:title',
        name: 'movie_1',
        meta: {
          mtype: 'detail',
        },
        component: () => import(/* webpackChunkName: "movieDetail" */ '../page/detail/Movie.vue'),
      },
      {
        path: '/movie/:key',
        name: 'movie',
        meta: {
          mtype: 'detail',
        },
        component: () => import(/* webpackChunkName: "movieDetail" */ '../page/detail/Movie.vue'),
      },
      // 电影simple页
      {
        path: '/dypy/:dockey',
        name: 'movie_simple',
        meta: {
          mtype: 'detail',
        },
        component: () => import(/* webpackChunkName: "movieSimpleDetail" */ '../page/detail/MovieSimple.vue'),
      },
      {
        path: '/dypy/:dockey/:title',
        name: 'movie_simple_1',
        meta: {
          mtype: 'detail',
        },
        component: () => import(/* webpackChunkName: "movieSimpleDetail" */ '../page/detail/MovieSimple.vue'),
      },
      // 电视剧详情页
      {
        path: '/dsj/:dockey/:title',
        name: 'teleplay_1',
        meta: {
          mtype: 'detail',
        },
        component: () => import(/* webpackChunkName: "teleplayDetail" */ '../page/detail/Teleplay.vue'),
      },
      {
        path: '/teleplay/:key',
        name: 'teleplay',
        meta: {
          mtype: 'detail',
        },
        component: () => import(/* webpackChunkName: "teleplayDetail" */ '../page/detail/Teleplay.vue'),
      },
      // 动漫详情页
      {
        path: '/series/:key',
        name: 'series',
        meta: {
          mtype: 'detail',
        },
        component: () => import(/* webpackChunkName: "cartoonDetail" */ '../page/detail/Cartoon.vue'),
      },
      {
        path: '/dm/:dockey/:title',
        name: 'cartoon_1',
        meta: {
          mtype: 'detail',
        },
        component: () => import(/* webpackChunkName: "cartoonDetail" */ '../page/detail/Cartoon.vue'),
      },
      {
        path: '/cartoon/:key',
        name: 'cartoon',
        meta: {
          mtype: 'detail',
        },
        component: () => import(/* webpackChunkName: "cartoonDetail" */ '../page/detail/Cartoon.vue'),
      },
      // 综艺详情页
      {
        path: '/zy/:dockey/:title',
        name: 'tvshow_1',
        meta: {
          mtype: 'detail',
        },
        component: () => import(/* webpackChunkName: "tvshowDetail" */ '../page/detail/Tvshow.vue'),
      },
      {
        path: '/tvshow/:key',
        name: 'tvshow',
        meta: {
          mtype: 'detail',
        },
        component: () => import(/* webpackChunkName: "tvshowDetail" */ '../page/detail/Tvshow.vue'),
      },
      // 剧情剧照详情页
      {
        path: '/summary/:type',
        name: 'summary',
        meta: {
          mtype: 'summary',
        },
        component: () => import(/* webpackChunkName: "summary" */ '../page/summary/Index.vue'),
      },
      // 播单列表
      {
        path: '/playlist/:key',
        name: 'playlist',
        meta: {
          mtype: 'playlist',
        },
        component: () => import(/* webpackChunkName: "playlist" */ '../page/playlist/Index.vue'),
      },
      // 寻址页
      {
        path: '/qlist/:key',
        name: 'qlist',
        meta: {
          mtype: 'qlist',
        },
        component: () => import(/* webpackChunkName: "qlist" */ '../page/qlist/Index.vue'),
      },
      // 错误页
      {
        path: '/error',
        name: 'error',
        meta: {
          mtype: 'error',
        },
        component: () => import(/* webpackChunkName: "error" */ '../page/error/Index.vue'),
      },
      // up 主详情页
      {
        path: '/uploader',
        name: 'uploader',
        meta: {
          mtype: 'uploader',
        },
        component: () => import(/* webpackChunkName: "uploader" */ '../page/uploader/Index.vue'),
      },
      // 通用视频页
      {
        path: '/savideo',
        name: 'savideo',
        meta: {
          mtype: 'savideo',
        },
        component: () => import(/* webpackChunkName: "savideo" */ '../page/savideo/Index.vue'),
      },
      {
        path: '*',
        component: ErrIndex,
      },
    ],
  });
}
